module.exports = __webpack_public_path__ + "media/images/emp/nist_logo_reverse-5d5480a9ce8b7cc1e474c44456aeae22.svg";